import { Message } from "primereact/message";
import { Messages } from "primereact/messages";
import { ProgressBar } from "primereact/progressbar";
import React, { useRef } from "react";

export interface ResultWithProgressProps {
  isObserving: boolean,
  progress: number | null,
  lastLog: string,
  logs: string[],
  isError: boolean,
  error: Error | null,
  children?: React.ReactNode
}

const ResultWithProgress : React.FC<ResultWithProgressProps> =
  ({ isObserving, progress, lastLog,logs, isError, error, children }) => {
    const messages = useRef<Messages>(null);
    if(isError){
      return (
        <div className="p-message p-component p-message-error p-message-enter-done">
          <div className="p-message-wrapper flex flex-row align-items-center gap-2">
            <i className="pi pi-times-circle" style={{position: "relative",top: "2px"}}></i>
            <span className="p-message-summary">エラー</span>
            <span className="p-message-detail">{lastLog}</span>
            <span className="p-message-detail">{error?.message}</span>
          </div>
        </div>
      )
    }
    if(isObserving || children === undefined){
      if(isObserving){
        return (
          <div className="p-3 surface-ground border-round w-full">
            {progress !== null && (progress! > 0.1) ? (
              <ProgressBar value={Math.round(progress * 100)} showValue={true} />
            ) : (
              <ProgressBar mode="indeterminate" />
            )}
            <p className="mx-auto text-center">{lastLog}</p>
          </div>
        )
      } else {
        return (
        <div className="p-3 surface-ground border-round w-full">
          <ProgressBar value={100} showValue={true} />
          <p className="mx-auto text-center">処理が完了しました</p>
        </div>
        )
      }
    }
    return (
      <>
        {children}
      </>
    )
  };

export default ResultWithProgress;
